import { Button, FloatingLabel, Form, Offcanvas } from "olive-react-myoneui";
import DropdownCommon from "../component/DropdownCommon";
import { useEffect, useState } from "react";
import TagDropdown from "../component/TagDropdown";

function EditOffcanvas({
    show,
    onClose,
    topic,
    subTopic,
    setSubTopic,
    handleeditSubTopic,
    selectedTopic,
    setSelectedTopic,
    subTopicList,
    setSubtopicList,
    subTopicId,
    selectedRelatedSubTop,
    setSelectedRelatedSubTop,
    selectedRelatedSubTopId,
    handleSubmit,
})
{
  const [category, setCategory] = useState([]);

  const keywordHandler = (selectedTags) => {
    setCategory(selectedTags);
  };


  useEffect(()=>{
    if (selectedRelatedSubTop){
        setCategory(selectedRelatedSubTop)
    }
      },[selectedRelatedSubTop])

  return (
    <>
      <Offcanvas className="pb-0" show={show} onHide={onClose} placement="end">
        <Offcanvas.Header
          closeButton
          backButton="Close"
          icon="close"
          className="pb-0"
        >
          <Offcanvas.Title>Edit Sub-Topics</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <p className="help-text fs-6 fw-semibold">
            Please fill the form below and edit sub-topics.
          </p>

          <FloatingLabel
            controlId="subTopicsId"
            label="Sub-Topics"
            className="mb-4"
          >
            <Form.Control
              type="text"
              placeholder="Sub-Topics"
              value={subTopic}
              onChange={(e) => setSubTopic(e?.target?.value)}
            />
          </FloatingLabel>
         <DropdownCommon
            className="mb-4"
            name="Topics"
            selectedValue={selectedTopic}
            setSelectedValue={setSelectedTopic}
            items={topic}
            label="Topics"
          />
           <TagDropdown
                        className="custom-tag-content mb-4"
                        tagTitle="Related Sub-Topics *"
                        list={subTopicList}
                        keywords={category}
                        onTags={keywordHandler}
                        placeholder="Select related sub-topic"
                        placeholderTitle="Select related sub-topic"
                    />
        </Offcanvas.Body>
        <Offcanvas.Footer>
            <Button variant="default" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={() => handleSubmit( subTopic,selectedTopic?._id,subTopicId,category)}>
            Save
          </Button>
        </Offcanvas.Footer>
      </Offcanvas>
    </>
  );

}
export default EditOffcanvas;
